// Stałe kolory używane w generowanych awatarach
const AVATAR_COLORS = [
  "#4F46E5", // indigo
  "#10B981", // emerald
  "#F59E0B", // amber
  "#EF4444", // red
  "#8B5CF6", // violet
  "#EC4899", // pink
  "#06B6D4", // cyan
  "#F97316", // orange
  "#047857", // green
  "#7C3AED", // purple
  "#BE123C", // rose
  "#0369A1", // sky
  "#A16207", // yellow
  "#0F172A", // slate
  "#374151", // gray
  "#1D4ED8", // blue
  "#4338CA", // indigo light
  "#6D28D9", // violet dark
  "#D97706", // amber dark
  "#DC2626", // red bright
];

// Lista predefiniowanych awatarów
export const PREDEFINED_AVATARS = [
  // Kolekcja Vibrent - nowoczesne avatary
  {
    id: "vibrent-1",
    url: "https://cdn.jsdelivr.net/gh/alohe/avatars/png/vibrent_1.png",
    name: "Vibrent 1",
    fallbackColor: AVATAR_COLORS[0],
    category: "vibrent",
  },
  {
    id: "vibrent-2",
    url: "https://cdn.jsdelivr.net/gh/alohe/avatars/png/vibrent_2.png",
    name: "Vibrent 2",
    fallbackColor: AVATAR_COLORS[1],
    category: "vibrent",
  },
  {
    id: "vibrent-3",
    url: "https://cdn.jsdelivr.net/gh/alohe/avatars/png/vibrent_3.png",
    name: "Vibrent 3",
    fallbackColor: AVATAR_COLORS[2],
    category: "vibrent",
  },
  {
    id: "vibrent-4",
    url: "https://cdn.jsdelivr.net/gh/alohe/avatars/png/vibrent_4.png",
    name: "Vibrent 4",
    fallbackColor: AVATAR_COLORS[3],
    category: "vibrent",
  },
  {
    id: "vibrent-5",
    url: "https://cdn.jsdelivr.net/gh/alohe/avatars/png/vibrent_5.png",
    name: "Vibrent 5",
    fallbackColor: AVATAR_COLORS[4],
    category: "vibrent",
  },
  {
    id: "vibrent-6",
    url: "https://cdn.jsdelivr.net/gh/alohe/avatars/png/vibrent_6.png",
    name: "Vibrent 6",
    fallbackColor: AVATAR_COLORS[5],
    category: "vibrent",
  },
  {
    id: "vibrent-7",
    url: "https://cdn.jsdelivr.net/gh/alohe/avatars/png/vibrent_7.png",
    name: "Vibrent 7",
    fallbackColor: AVATAR_COLORS[6],
    category: "vibrent",
  },
  {
    id: "vibrent-8",
    url: "https://cdn.jsdelivr.net/gh/alohe/avatars/png/vibrent_8.png",
    name: "Vibrent 8",
    fallbackColor: AVATAR_COLORS[7],
    category: "vibrent",
  },
  {
    id: "vibrent-9",
    url: "https://cdn.jsdelivr.net/gh/alohe/avatars/png/vibrent_9.png",
    name: "Vibrent 9",
    fallbackColor: AVATAR_COLORS[8],
    category: "vibrent",
  },
  {
    id: "vibrent-10",
    url: "https://cdn.jsdelivr.net/gh/alohe/avatars/png/vibrent_10.png",
    name: "Vibrent 10",
    fallbackColor: AVATAR_COLORS[9],
    category: "vibrent",
  },
  {
    id: "vibrent-11",
    url: "https://cdn.jsdelivr.net/gh/alohe/avatars/png/vibrent_11.png",
    name: "Vibrent 11",
    fallbackColor: AVATAR_COLORS[10],
    category: "vibrent",
  },
  {
    id: "vibrent-12",
    url: "https://cdn.jsdelivr.net/gh/alohe/avatars/png/vibrent_12.png",
    name: "Vibrent 12",
    fallbackColor: AVATAR_COLORS[11],
    category: "vibrent",
  },
  {
    id: "vibrent-13",
    url: "https://cdn.jsdelivr.net/gh/alohe/avatars/png/vibrent_13.png",
    name: "Vibrent 13",
    fallbackColor: AVATAR_COLORS[12],
    category: "vibrent",
  },
  {
    id: "vibrent-14",
    url: "https://cdn.jsdelivr.net/gh/alohe/avatars/png/vibrent_14.png",
    name: "Vibrent 14",
    fallbackColor: AVATAR_COLORS[13],
    category: "vibrent",
  },
  {
    id: "vibrent-15",
    url: "https://cdn.jsdelivr.net/gh/alohe/avatars/png/vibrent_15.png",
    name: "Vibrent 15",
    fallbackColor: AVATAR_COLORS[14],
    category: "vibrent",
  },
  {
    id: "vibrent-16",
    url: "https://cdn.jsdelivr.net/gh/alohe/avatars/png/vibrent_16.png",
    name: "Vibrent 16",
    fallbackColor: AVATAR_COLORS[15],
    category: "vibrent",
  },
  {
    id: "vibrent-17",
    url: "https://cdn.jsdelivr.net/gh/alohe/avatars/png/vibrent_17.png",
    name: "Vibrent 17",
    fallbackColor: AVATAR_COLORS[16],
    category: "vibrent",
  },
  {
    id: "vibrent-18",
    url: "https://cdn.jsdelivr.net/gh/alohe/avatars/png/vibrent_18.png",
    name: "Vibrent 18",
    fallbackColor: AVATAR_COLORS[17],
    category: "vibrent",
  },
  {
    id: "vibrent-19",
    url: "https://cdn.jsdelivr.net/gh/alohe/avatars/png/vibrent_19.png",
    name: "Vibrent 19",
    fallbackColor: AVATAR_COLORS[18],
    category: "vibrent",
  },
  {
    id: "vibrent-20",
    url: "https://cdn.jsdelivr.net/gh/alohe/avatars/png/vibrent_20.png",
    name: "Vibrent 20",
    fallbackColor: AVATAR_COLORS[19],
    category: "vibrent",
  },
  {
    id: "vibrent-21",
    url: "https://cdn.jsdelivr.net/gh/alohe/avatars/png/vibrent_21.png",
    name: "Vibrent 21",
    fallbackColor: AVATAR_COLORS[0],
    category: "vibrent",
  },
  {
    id: "vibrent-22",
    url: "https://cdn.jsdelivr.net/gh/alohe/avatars/png/vibrent_22.png",
    name: "Vibrent 22",
    fallbackColor: AVATAR_COLORS[1],
    category: "vibrent",
  },
  {
    id: "vibrent-23",
    url: "https://cdn.jsdelivr.net/gh/alohe/avatars/png/vibrent_23.png",
    name: "Vibrent 23",
    fallbackColor: AVATAR_COLORS[2],
    category: "vibrent",
  },
  {
    id: "vibrent-24",
    url: "https://cdn.jsdelivr.net/gh/alohe/avatars/png/vibrent_24.png",
    name: "Vibrent 24",
    fallbackColor: AVATAR_COLORS[3],
    category: "vibrent",
  },
  {
    id: "vibrent-25",
    url: "https://cdn.jsdelivr.net/gh/alohe/avatars/png/vibrent_25.png",
    name: "Vibrent 25",
    fallbackColor: AVATAR_COLORS[4],
    category: "vibrent",
  },
  {
    id: "vibrent-26",
    url: "https://cdn.jsdelivr.net/gh/alohe/avatars/png/vibrent_26.png",
    name: "Vibrent 26",
    fallbackColor: AVATAR_COLORS[5],
    category: "vibrent",
  },
  {
    id: "vibrent-27",
    url: "https://cdn.jsdelivr.net/gh/alohe/avatars/png/vibrent_27.png",
    name: "Vibrent 27",
    fallbackColor: AVATAR_COLORS[6],
    category: "vibrent",
  },
];

/**
 * Generuje awatar algorytmicznie na podstawie inicjałów
 * @param {string} name - Imię i/lub nazwisko użytkownika
 * @param {number} size - Rozmiar awatara w pikselach
 * @param {string} background - Kolor tła (hex)
 * @returns {string} - Adres URL wygenerowanego awatara (lub pusty string w przypadku błędu)
 */
export const generateInitialsAvatar = (
  name,
  size = 200,
  customBackground = null
) => {
  try {
    // Pobierz inicjały
    const initials = getInitials(name);

    // Wybierz kolor tła
    const background = customBackground || getColorFromName(name);

    // Tworzymy SVG z inicjałami
    const svg = `
      <svg width="${size}" height="${size}" viewBox="0 0 ${size} ${size}" xmlns="http://www.w3.org/2000/svg">
        <rect width="${size}" height="${size}" fill="${background}" />
        <text x="${size / 2}" y="${size / 2}" dy=".1em" fill="white" font-family="Arial, sans-serif" font-size="${size / 2.5}" font-weight="bold" text-anchor="middle" dominant-baseline="middle">${initials}</text>
      </svg>
    `;

    // Konwertujemy SVG do Data URL
    return `data:image/svg+xml;base64,${btoa(svg)}`;
  } catch (error) {
    console.error("Błąd generowania awatara:", error);
    return "";
  }
};

/**
 * Pobiera inicjały z imienia
 * @param {string} name - Imię i/lub nazwisko
 * @returns {string} - Inicjały (1-2 znaki)
 */
export const getInitials = (name) => {
  if (!name) return "?";

  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) {
    return parts[0].charAt(0).toUpperCase();
  } else {
    return (
      parts[0].charAt(0) + parts[parts.length - 1].charAt(0)
    ).toUpperCase();
  }
};

/**
 * Generuje kolor bazując na stringu (imię, email)
 * @param {string} str - String, z którego generowany jest kolor
 * @returns {string} - Kolor w formacie HEX
 */
export const getColorFromName = (str) => {
  if (!str) return AVATAR_COLORS[0];

  // Wyliczamy sumę kodów ASCII
  let sum = 0;
  for (let i = 0; i < str.length; i++) {
    sum += str.charCodeAt(i);
  }

  return AVATAR_COLORS[sum % AVATAR_COLORS.length];
};

/**
 * Generuje avatary do wyboru dla użytkownika
 * @returns {Array} - Tablica zawierająca wszystkie dostępne awatary
 */
export const getAllAvatars = (displayName, email) => {
  const defaultName =
    displayName || (email ? email.split("@")[0] : "Użytkownik");

  // Zestaw 1: Predefiniowane avatary z plików
  const fileAvatars = [...PREDEFINED_AVATARS];

  // Zestaw 2: Avatary kolorowe wygenerowane z inicjałów
  const colorAvatars = AVATAR_COLORS.map((color, index) => ({
    id: `color-${index}`,
    url: generateInitialsAvatar(defaultName, 200, color),
    name: `Kolor ${index + 1}`,
    fallbackColor: color,
    isGenerated: true,
  }));

  return [...fileAvatars, ...colorAvatars];
};

/**
 * Pobiera URL awatara lub generuje awatar zastępczy
 * @param {string} photoURL - URL zdjęcia profilowego
 * @param {string} nameOrEmail - Imię lub email użytkownika do wygenerowania fallbacka
 * @returns {string} - URL awatara lub wygenerowany awatar
 */
export const getAvatarUrl = (photoURL, nameOrEmail) => {
  try {
    // Sprawdzamy czy photoURL jest prawidłowym URL
    if (photoURL && photoURL.trim() !== "") {
      // Sprawdzamy czy URL jest poprawny - zaczyna się od http, https lub data:
      if (photoURL.startsWith("http") || photoURL.startsWith("data:")) {
        // Dodajemy timestamp do URL, aby wymusić odświeżenie obrazu (cache busting)
        if (photoURL.startsWith("http")) {
          const separator = photoURL.includes("?") ? "&" : "?";
          return `${photoURL}${separator}_t=${Date.now()}`;
        }
        return photoURL;
      }
    }

    console.log("Generuję avatar dla:", nameOrEmail);
    // Jeśli nie ma URL do zdjęcia lub URL jest niepoprawny, generujemy awatar z inicjałów
    return generateInitialsAvatar(nameOrEmail || "");
  } catch (error) {
    console.error("Błąd podczas pobierania URL awatara:", error);
    // W przypadku błędu zwracamy prosty wygenerowany awatar
    return generateInitialsAvatar(nameOrEmail || "");
  }
};
